module.exports = __webpack_public_path__ + "static/media/ICA Crew Service User Guide.9b4a2c8f.pdf";